<template>
  <v-toolbar v-bind:class="toolbarColor" dark dense>
    <img v-bind:src="toolbarLogo">
    <v-toolbar-title class="hidden-xs-and-down">
      {{ toolbarTitle }}
    </v-toolbar-title>
    <v-spacer />
    <v-btn
      v-tooltip:left="toolTipMinimize"
      v-on:click.native="toggleMinimize"
      v-if="$store.state.isRunningEmbedded"
      icon
      light
    >
      <v-icon>
        {{ isUiMinimized ?  'arrow_drop_up' : 'arrow_drop_down' }}
      </v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
/*
Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
export default {
  name: 'toolbar-container',
  props: ['toolbarTitle', 'toolbarColor', 'toolbarLogo', 'isUiMinimized'],
  computed: {
    toolTipMinimize() {
      return {
        html: (this.isUiMinimized) ? 'maximize' : 'minimize',
      };
    },
  },
  methods: {
    toggleMinimize() {
      this.$emit('toggleMinimizeUi');
    },
  },
};
</script>



// WEBPACK FOOTER //
// ToolbarContainer.vue?afb1d408